export default __webpack_public_path__ + "static/media/kitchen3-afterA-1440w.306e417b.avif";